<template>
	<div>
		<div style="background-color: white;" v-if="data.length==0">
			<a-result  title="暂无数据">
			   
			  </a-result>
		</div>
		<div class="cardHover" style="width: 50.75rem;height: 254px;background: #FFFFFF;
		border-radius: 4px;position: relative;margin-bottom: 0.9375rem;" v-for="(item,i) in data" >
				<p class="title_t">
					{{item.examPaperName}}
				</p>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>总分{{item.totalMark}}分，及格分数{{item.passMark}}分</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>平台：</p>
					<p>{{item.lab.labName}}</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>考试时长：</p>
					<p>{{item.examMinute}} min</p>
				</div>
				<div class="title_b" style="display: flex;margin-left: 1.5625rem;">
					<p>发布时间：</p>
					<p>{{item.createTime.split('T')[0]}}</p>
				</div>
				
				<div style="display: flex;flex-direction: column;width: 6.625rem;position: absolute;right: 1.25rem;bottom: 0;">
					<a-button @click="showCalendarModal(item)" style="margin: 0.9375rem 0;" type="primary">
						开始
					</a-button>
				</div>
			</div>
			<div style="position: absolute;bottom: 2.1875rem;">
				<a-pagination :defaultPageSize="5" :pageSizeOptions="['5', '10', '20', '40']" v-model="queryPage.current"
					@showSizeChange="changeSize" @change="changeCurrent"
					style="display: block !important;margin-left: 15.625rem" size="small" :total="total" show-size-changer
					show-quick-jumper />
			</div>
	</div>
	
</template>

<script>
	import {SelExamPaper,SelExamPaperType} from '@/api/index.js'
	export default {
		props: ['id','length'],
		data() {
			return {
				queryPage: {
					current: 1,
					pageSize: 5
				},
				data:[],
				total:1
			}
		},
		methods: {
			showCalendarModal(item){
				this.$router.push({name:'examDetail',query:{id:item.examPaperId}})
			},
			changeCurrent(val) {
				
				this.queryPage.current = val
					
				this.getSelExamPaper()
			},
			changeSize(current, size) {
				console.log("ddd")
				this.queryPage.pageSize = size
				this.queryPage.current = current
				this.getSelExamPaper()
			},
			async getSelExamPaper(){
				if(this.id=='空白'){
					this.id=undefined
				}
				let data = {
					ExamPaperTypeId:this.id,
					name:window.localStorage.getItem('searchValues'),
					page:this.queryPage.current,
					row:this.queryPage.pageSize,
				}
				let res = await SelExamPaper(data)
				this.data = res.data.data
				this.total = res.data.totalCount
				
				console.log(res)
			}
			
		},
		created(){
			this.getSelExamPaper()
		},
		
	}
</script>

<style scoped>
	.title_t {
		font-size: 1rem;
		color: rgba(0, 0, 0, 0.85);
		padding: 1.5625rem;
	}

	.title_b {
		font-size: 0.875rem;
		color: rgba(0, 0, 0, 0.65);
	}

	.a-button {
		width: 6.625rem !important;
		height: 2.5rem !important;
	}
</style>
<style lang="scss">
	.signModal {
		.ant-modal-title {
			font-size: 1.125rem;
			color: rgba(0, 0, 0, 0.85);
			font-weight: 700;
		}
	}

	.calendarModal {
		.ant-modal-content {
			// width: 51.5rem!important;
			height: auto !important;
		}

		.ant-modal-header {
			display: none;
		}

		.ant-modal-close {
			display: none;
		}

		.ant-btn {
			margin: 0 1.5625rem !important;
		}
	}


</style>
